import { SchoolClass, User } from '@/types';

import client from './client';

export function user(): Promise<User> {
	return client.get('/api/user').then(resp => resp.json());
}

export function tokenLogin(token: string, active_school_id: string): Promise<User> {
	return client.post('/api/auth/token', { token, active_school_id }).then(resp => resp.json());
}

export function logout(): Promise<Response> {
	return client.delete('/api/auth/logout');
}

export function getSchoolClassesFromProvider(): Promise<SchoolClass[]> {
	return client.get(`/api/school-classes`).then(resp => resp.json());
}
